import '../scss/app.scss';
import './sprites.js';
/* Your JS Code goes here */

/* Demo JS */
import 'flickity/dist/flickity.min.css';
import 'nice-select2/dist/css/nice-select2.css';
import './main';
import './validateForm';
